export default "__VITE_ASSET__4cd989ee__"